import { ref } from "vue";
import { useAxios } from "./useAxios";
import { useAuthStore } from "@/stores/auth";

export function useChangePassword() {
  const { makeRequest, results, error } = useAxios();
  const authStore = useAuthStore();
  const loading = ref(false);
  const locError = ref(null); // locError local para validación y locErrores propios

  const passwordComplexityRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

  const changePassword = async (newPassword, confirmPassword) => {
    locError.value = null;
    loading.value = true;

    await makeRequest(
      "post",
      { password: newPassword, password_confirmation: confirmPassword },
      "/api/v1/auth/change-password",
      "", // sin redirect
      false, // mostrar mensaje de éxito
      "", // settings vacíos
      false, // reloadTable
      false // mostrar locError
    );

    loading.value = false;

    if (!error.value) {
      await swal.fire({
        icon: "success",
        title: "Contraseña cambiada",
        text: "Contraseña modificada correctamente.",
        confirmButtonText: "OK",
      });
      authStore.mustChangePasswordModal = false;
      return true;
    } else {
      // asignamos el locError del request si hubo
      locError.value =
        error.value?.response?.data?.message || "Error desconocido";
      return false;
    }
  };

  return {
    changePassword,
    locError,
    loading,
    results,
  };
}
